// Default fallback image
const DEFAULT_LOGO = "unknown_logo.png";

// Utility function to safely load an image with require
export const safeRequireImage = (imagePath) => {
  try {
    // Attempt to require the specified image
    return require(`../../assets/images/${imagePath}`);
  } catch (error) {
    console.warn(
      `Image ${imagePath} not found, attempting fallback: ${DEFAULT_LOGO}`
    );
    try {
      // Attempt to require the fallback image
      return require(`../../assets/images/${DEFAULT_LOGO}`);
    } catch (fallbackError) {
      console.error(`Fallback image ${DEFAULT_LOGO} not found:`, fallbackError);
      // Return a placeholder or empty string to avoid breaking the component
      return "";
    }
  }
};
